import * as React from "react"
import Svg, { LinearGradient, Stop, Path } from "react-native-svg"

function SvgComponent(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="48px"
      height="48px"
      {...props}
    >
      <LinearGradient
        id="a"
        x1={13.302}
        x2={53.378}
        y1={-75.302}
        y2={-115.378}
        gradientTransform="matrix(1 0 0 -1 0 -62)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0} stopColor="#dfe9f2" />
        <Stop offset={0.998} stopColor="#9ea7b0" />
      </LinearGradient>
      <Path
        fill="url(#a)"
        d="M44 24c0-11.045-8.955-20-20-20S4 12.955 4 24s8.955 20 20 20 20-8.955 20-20z"
      />
      <Path
        fill="#263238"
        d="M11.91 21.096l4.355-6.711.59.383-4.355 6.707-.59-.379zM8.793 28.928l.672-.434 4.348 6.715-.668.434-4.352-6.715zM32.664 13.74l.668-.434 4.426 6.781-.672.438-4.422-6.785zM10.344 20.127l4.355-6.711.586.379-4.355 6.711-.586-.379zM33.445 18.4l.586-.383 2.016 3.105-.59.383-2.012-3.105zM36.453 31.643l2.016-3.105.586.383-2.016 3.102-.586-.38zM12.637 31.51l.586-.379 2.016 3.102-.586.383-2.016-3.106zM36.559 16.416l.586-.383 2.027 3.094-.586.383-2.027-3.094zM33.371 29.619l2.016-3.105.586.383-2.016 3.102-.586-.38zM34.937 30.588l2.023-3.102.668.438-2.02 3.102-.671-.438zM31.148 14.768l.586-.383 2.027 3.094-.586.383-2.027-3.094zM34.105 35.221l1.996-3.117.59.379-2 3.113-.586-.375zM10.352 27.865l.672-.434 2 3.113-.672.434-2-3.113zM34.266 12.771l.586-.387 2.031 3.094-.586.383-2.031-3.09zM31.008 33.17l2.02-3.098.672.438-2.023 3.098-.669-.438zM32.535 34.24l2.004-3.109.672.434-2.004 3.109-.672-.434zM8.758 19.139l4.43-6.781.672.438-4.43 6.781-.672-.438zM11.855 26.85l.59-.383 4.348 6.715-.586.383-4.352-6.715z"
      />
      <LinearGradient
        id="b"
        x1={20.232}
        x2={29.751}
        y1={19.235}
        y2={29.501}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0.008} stopColor="#f44f5a" />
        <Stop offset={0.447} stopColor="#ee3d4a" />
        <Stop offset={1} stopColor="#e52030" />
      </LinearGradient>
      <Path
        fill="url(#b)"
        d="M20.5 27.482c1.924 0 3.5-1.576 3.5-3.5s1.576-3.5 3.5-3.5 3.5 1.576 3.5 3.5c0-3.849-3.151-7-7-7s-7 3.151-7 7a3.51 3.51 0 003.5 3.5z"
      />
      <LinearGradient
        id="c"
        x1={22.015}
        x2={30.458}
        y1={21.941}
        y2={33.109}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0} stopColor="#0d61a9" />
        <Stop offset={1} stopColor="#16528c" />
      </LinearGradient>
      <Path
        fill="url(#c)"
        d="M27.5 20.482c-1.924 0-3.5 1.576-3.5 3.5s-1.576 3.5-3.5 3.5-3.5-1.576-3.5-3.5c0 3.849 3.151 7 7 7s7-3.151 7-7c0-1.924-1.576-3.5-3.5-3.5z"
      />
    </Svg>
  )
}

export default SvgComponent
